import { render, staticRenderFns } from "./invoice-payment-card.vue?vue&type=template&id=3b6b28d6&"
import script from "./invoice-payment-card.vue?vue&type=script&lang=js&"
export * from "./invoice-payment-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports